import img from '../../../img/pizza1.svg'
import img2 from '../../../img/pizza2.svg'
import img3 from '../../../img/pizza3.svg'
import img4 from '../../../img/pizza4.svg'


export const pizzaData = [
    {
        img: img,
        name: 'Чикен Сладкий Чили',
        text: 'Курица, Лук, Перец Халапеньо, Сыр Моцарелла, Томатный соу...',
        price: 'от 399 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'pizza#1'
    },
    {
        img: img2,
        name: 'EASY PEASY огуречный расколбас',
        text: 'Курица, Лук, Перец Халапеньо...',
        price: 'от 549 ₽',
        size: '20',
        quality: 'Traditional',
        isMonzarella: false,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'pizza#2'
    },
    {
        img: img3,
        name: 'EASY PEASY огуречный расколбас',
        text: 'Курица, Лук, Перец Халапеньо...',
        price: 'от 249 ₽',
        size: '20',
        quality: 'Traditional',
        isMonzarella: false,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'pizza#3'
    },
    {
        img: img4,
        name: 'EASY PEASY огуречный расколбас',
        text: 'Курица, Лук, Перец Халапеньо...',
        price: 'от 630 ₽',
        size: '20',
        quality: 'Traditional',
        isMonzarella: false,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'pizza#4'
    },
    {
        img: img4,
        name: 'EASY PEASY огуречный расколбас',
        text: 'Курица, Лук, Перец Халапеньо...',
        price: 'от 630 ₽',
        size: '20',
        quality: 'Traditional',
        isMonzarella: false,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'pizza#5'
    },
    {
        img: img3,
        name: 'EASY PEASY огуречный расколбас',
        text: 'Курица, Лук, Перец Халапеньо...',
        price: 'от 249 ₽',
        size: '20',
        quality: 'Traditional',
        isMonzarella: false,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'pizza#6'
    },
    {
        img: img,
        name: 'EASY PEASY огуречный расколбас',
        text: 'Курица, Лук, Перец Халапеньо...',
        price: 'от 399 ₽',
        size: '20',
        quality: 'Traditional',
        isMonzarella: false,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'pizza#7'
    },
    {
        img: img2,
        name: 'EASY PEASY огуречный расколбас',
        text: 'Курица, Лук, Перец Халапеньо...',
        price: 'от 549 ₽',
        size: '20',
        quality: 'Traditional',
        isMonzarella: false,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'pizza#8'
    },

]